import React from "react";
import { CloseCircleOutlined } from "@ant-design/icons";
import { Progress } from "antd";
import { useTranslation } from "react-i18next";

const ProcessRender = ({
  hideCancelText,
  showProcessText,
  processText,
  cancelProcess,
  uploadPercent,
  processPercent,
  processStep,
  hideCancelBtn,
}) => {
  const { t } = useTranslation(["common"]);
  return (
    <div className="upload-square">
      {hideCancelBtn ? null : (
        <div className="close" onClick={cancelProcess}>
          <CloseCircleOutlined style={{ color: "#A1A1A2" }} />
          {hideCancelText ? "" : t("Cancel")}
        </div>
      )}
      <div style={{ width: "100%", height: "100%" }}>
        <Progress
          showInfo={false}
          strokeColor="#58528B"
          status="active"
          percent={parseInt((uploadPercent + processPercent) / processStep)}
          style={{ width: "400px", maxWidth: "100%", height: "100%" }}
        />
        {showProcessText ? <span className="process-text">{processText ? t(processText) : t("Uploading")}</span> : ""}
      </div>
    </div>
  );
};

export default ProcessRender;
